import { render, staticRenderFns } from "./LiveAnswer.vue?vue&type=template&id=2a781148&scoped=true&"
import script from "./LiveAnswer.vue?vue&type=script&lang=js&"
export * from "./LiveAnswer.vue?vue&type=script&lang=js&"
import style0 from "./LiveAnswer.vue?vue&type=style&index=0&id=2a781148&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a781148",
  null
  
)

export default component.exports